import { Card, Center, Group, Text, Title } from '@mantine/core';
import { CenteredLoading } from 'components/CenteredLoading';
import { PriorityKeys } from 'models/rules';
import { RoutePath, useNavigateToRoute } from 'utils/location';
import classes from 'global.module.css';
import { getPriorityInfo } from 'utils/worklist';
import { useGetWorklistRecordsTotal } from 'hooks/api/worklist/useGetWorklistRecordsTotal';
import { useTranslation } from 'react-i18next';

interface PriorityCardProps {
  priority: PriorityKeys;
}

export const PriorityCard = ({ priority }: PriorityCardProps) => {
  const { data: value, isLoading } = useGetWorklistRecordsTotal({ priority });
  const { color, label, filter } = getPriorityInfo(priority);
  const navigateToRoute = useNavigateToRoute();
  const { t } = useTranslation();

  return (
    <Card
      className={classes.dashboardCard}
      w={100}
      shadow={'sm'}
      radius={'lg'}
      style={{
        backgroundColor: color,
        color: 'var(--mantine-color-white)',
        cursor: 'pointer',
      }}
      onClick={() => navigateToRoute(RoutePath.Worklist, { priority: filter })}
    >
      <Card.Section withBorder inheritPadding py={'xs'}>
        <Center my={'md'}>
          <Title order={2} data-testid={`card-priority-value=${priority}`}>
            {isLoading ? <CenteredLoading /> : value}
          </Title>
        </Center>
      </Card.Section>
      <Card.Section
        withBorder
        inheritPadding
        py={'xs'}
        style={{ backgroundColor: 'var(--mantine-color-white)', color: 'var(--mantine-color-blue-7)' }}
      >
        <Group justify={'center'}>
          <Text size={'xs'} fw={700} data-testid={`card-priority-text=${priority}`}>
            {t(label)}
          </Text>
        </Group>
      </Card.Section>
    </Card>
  );
};
